<template>
  <div
    class="text-center highlight"
    role="button"
  >
    <div
      class="d-flex
              justify-content-center
              align-items-center
              add-button
              p-2"
    >
      <span class="check-container">
        <span v-for="_ in showCols" :key="_" class="box1" />
      </span>
      <base-text
        class="ml-2 column-text" style="white-space: nowrap;"
      >
        {{ showCols }} Columns
      </base-text>
      <div v-if="showSelect" class=" check-container">
        <base-icon
          icon="check"
          class="mr-2 "
          :class="{'d-none': selectedNum !== showCols}"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RowWidth',
  props: {
    showCols: {
      type: Number,
      default: -1,
    },
    showSelect: {
      type: Boolean,
      default: false,
    },
    selectedNum: {
      type: Number,
      default: -1,
    },
  },
};
</script>

<style lang="scss">
.box1 {
  border: 0.599997px solid #000000;
  height:20px;
  width:5.6px;
  display: inline-block;
  margin:1px;
  border-radius: 1.2px;
}

.highlight{
  transition: opacity .3s ease;
    &:hover{
      background-color: #F0F0F0;
    }
}

.column-text{
  flex:3;
}

.check-container{
  flex:1;
}

.check-container1{
  flex:1;
}
</style>
